import { render } from "./businessInfo.vue?vue&type=template&id=97e0b464&scoped=true"
import script from "./businessInfo.vue?vue&type=script&lang=js"
export * from "./businessInfo.vue?vue&type=script&lang=js"

import "./businessInfo.vue?vue&type=style&index=0&id=97e0b464&lang=scss&scoped=true"
import "./businessInfo.vue?vue&type=style&index=1&id=97e0b464&lang=scss"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97e0b464"]])

export default __exports__